import image2 from "assets/images/2.png";
import image3 from "assets/images/3.png";
import image4 from "assets/images/4.png";
import image5 from "assets/images/5.png";
import image6 from "assets/images/6.png";
import image7 from "assets/images/7.png";
import image8 from "assets/images/8.png";
import image10 from "assets/images/10.png";
import image13 from "assets/images/13.png";
import image14 from "assets/images/14.png";
import image16 from "assets/images/16.png";
import image17 from "assets/images/17.png";
import image18 from "assets/images/18.png";
import image19 from "assets/images/19.png";
import image20 from "assets/images/20.png";
import openseaIcon from "assets/images/opensea.svg";
import Swiper from "swiper";

const Collection: React.FC = () => {
  return (
    <section className="collection padding-top padding-bottom">
      <div className="container">
        <div className="collection__wrapper">
          <div className="row g-4">
            <div className="col-lg-3">
              <div className="collection__header">
                <div className="collection__header-content">
                  <p className="subtitle">Collection</p>
                  <h2>Egyptian Punk NFTs items</h2>
                  <p>5,000 unique creations Start Minting</p>
                </div>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="swiper collection__slider1 swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden">
                <div
                  className="swiper-wrapper"
                  id="swiper-wrapper-2f7824367425c6a7"
                  aria-live="off"
                  style={{
                    cursor: "grab",
                    transitionDuration: "3000ms",
                    // transform: `translate3d(-1980px, 0px, 0px)`,
                  }}
                >

                  <div
                    className="swiper-slide swiper-slide-duplicate"
                    data-swiper-slide-index="0"
                    role="group"
                    aria-label="1 / 3"
                    style={{ width: "306px", marginRight: "24px" }}
                  >
                    <div className="collection__item">
                      <div className="collection__item-thumb">
                        <img src={image20} alt="NFT Image" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="swiper-slide swiper-slide-duplicate"
                    data-swiper-slide-index="1"
                    role="group"
                    aria-label="2 / 3"
                    style={{ width: "306px", marginRight: "24px" }}
                  >
                    <div className="collection__item">
                      <div className="collection__item-thumb">
                        <img src={image19} alt="NFT Image" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-prev"
                    data-swiper-slide-index="2"
                    role="group"
                    aria-label="3 / 3"
                    style={{ width: "306px", marginRight: "24px" }}
                  >
                    <div className="collection__item">
                      <div className="collection__item-thumb">
                        <img src={image18} alt="NFT Image" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="swiper-slide swiper-slide-duplicate-active"
                    data-swiper-slide-index="0"
                    role="group"
                    aria-label="1 / 3"
                    style={{ width: "306px", marginRight: "24px" }}
                  >
                    <div className="collection__item">
                      <div className="collection__item-thumb">
                        <img src={image17} alt="NFT Image" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="swiper-slide swiper-slide-duplicate-next"
                    data-swiper-slide-index="1"
                    role="group"
                    aria-label="2 / 3"
                    style={{ width: "306px", marginRight: "24px" }}
                  >
                    <div className="collection__item">
                      <div className="collection__item-thumb">
                        <img src={image16} alt="NFT Image" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="swiper-slide swiper-slide-prev"
                    data-swiper-slide-index="2"
                    role="group"
                    aria-label="3 / 3"
                    style={{ width: "306px", marginRight: "24px" }}
                  >
                    <div className="collection__item">
                      <div className="collection__item-thumb">
                        <img src={image14} alt="NFT Image" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="swiper-slide swiper-slide-duplicate swiper-slide-active"
                    data-swiper-slide-index="0"
                    role="group"
                    aria-label="1 / 3"
                    style={{ width: "306px", marginRight: "24px" }}
                  >
                    <div className="collection__item">
                      <div className="collection__item-thumb">
                        <img src={image13} alt="NFT Image" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="swiper-slide swiper-slide-duplicate swiper-slide-next"
                    data-swiper-slide-index="1"
                    role="group"
                    aria-label="2 / 3"
                    style={{ width: "306px", marginRight: "24px" }}
                  >
                    <div className="collection__item">
                      <div className="collection__item-thumb">
                        <img src={image2} alt="NFT Image" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-prev"
                    data-swiper-slide-index="2"
                    role="group"
                    aria-label="3 / 3"
                    style={{ width: "306px", marginRight: "24px" }}
                  >
                    <div className="collection__item">
                      <div className="collection__item-thumb">
                        <img src={image3} alt="NFT Image" />
                      </div>
                    </div>
                  </div>
                </div>
                <span
                  className="swiper-notification"
                  aria-live="assertive"
                  aria-atomic="true"
                ></span>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="swiper collection__slider2 swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden">
                <div
                  className="swiper-wrapper"
                  id="swiper-wrapper-ca93e6a2954110d5"
                  aria-live="off"

                  style={{
                    cursor: "grab",
                    transitionDuration: "3000ms",
                   // transform: `translate3d(-1980px, 0px, 0px)`,
                  }}
                >
                  <div
                    className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-active"
                    data-swiper-slide-index="0"
                    role="group"
                    aria-label="1 / 3"
                    style={{ width: "306px", marginRight: "24px" }}
                  >
                    <div className="collection__item">
                      <div className="collection__item-thumb">
                        <img src={image4} alt="NFT Image" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-next"
                    data-swiper-slide-index="1"
                    role="group"
                    aria-label="2 / 3"
                    style={{ width: "306px", marginRight: "24px" }}
                  >
                    <div className="collection__item">
                      <div className="collection__item-thumb">
                        <img src={image5} alt="NFT Image" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="swiper-slide swiper-slide-duplicate swiper-slide-prev"
                    data-swiper-slide-index="2"
                    role="group"
                    aria-label="3 / 3"
                    style={{ width: "306px", marginRight: "24px" }}
                  >
                    <div className="collection__item">
                      <div className="collection__item-thumb">
                        <img src={image6} alt="NFT Image" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="swiper-slide swiper-slide-active"
                    data-swiper-slide-index="0"
                    role="group"
                    aria-label="1 / 3"
                    style={{ width: "306px", marginRight: "24px" }}
                  >
                    <div className="collection__item">
                      <div className="collection__item-thumb">
                        <img src={image4} alt="NFT Image" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="swiper-slide swiper-slide-next"
                    data-swiper-slide-index="1"
                    role="group"
                    aria-label="2 / 3"
                    style={{ width: "306px", marginRight: "24px" }}
                  >
                    <div className="collection__item">
                      <div className="collection__item-thumb">
                        <img src={image5} alt="NFT Image" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="swiper-slide swiper-slide-duplicate-prev"
                    data-swiper-slide-index="2"
                    role="group"
                    aria-label="3 / 3"
                    style={{ width: "306px", marginRight: "24px" }}
                  >
                    <div className="collection__item">
                      <div className="collection__item-thumb">
                        <img src={image6} alt="NFT Image" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-active"
                    data-swiper-slide-index="0"
                    role="group"
                    aria-label="1 / 3"
                    style={{ width: "306px", marginRight: "24px" }}
                  >
                    <div className="collection__item">
                      <div className="collection__item-thumb">
                        <img src={image7} alt="NFT Image" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-next"
                    data-swiper-slide-index="1"
                    role="group"
                    aria-label="2 / 3"
                    style={{ width: "306px", marginRight: "24px" }}
                  >
                    <div className="collection__item">
                      <div className="collection__item-thumb">
                        <img src={image8} alt="NFT Image" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="swiper-slide swiper-slide-duplicate"
                    data-swiper-slide-index="2"
                    role="group"
                    aria-label="3 / 3"
                    style={{ width: "306px", marginRight: "24px" }}
                  >
                    <div className="collection__item">
                      <div className="collection__item-thumb">
                        <img src={image10} alt="NFT Image" />
                      </div>
                    </div>
                  </div>
                </div>
                <span
                  className="swiper-notification"
                  aria-live="assertive"
                  aria-atomic="true"
                ></span>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="collection__btn">
                <a href="https://opensea.io/collection/egyption-punks" className="default-btn default-btn--secondary">
                  <span>
                    <img
                      src={openseaIcon}
                      alt="opensea icon"
                      width="24"
                      height="24"
                    />
                    View On Opensea
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Collection;
